import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { UserProfile } from '../services/auth'
import { authClient, currentUser, hostedUiLogoutUrl } from '../services/auth'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<UserProfile | null>(currentUser())
  const error = ref<string | null>(null)
  const busy = ref(false)

  const isSignedIn = computed(() => user.value !== null)

  async function signIn(returnTo?: string): Promise<void> {
    busy.value = true
    try {
      window.location.assign(await authClient.beginLogin(returnTo))
    } finally {
      busy.value = false
    }
  }

  async function completeSignIn(search: string): Promise<string | null> {
    busy.value = true
    error.value = null
    try {
      await authClient.completeLogin(search)
      user.value = currentUser()
      return authClient.takeReturnTo()
    } finally {
      busy.value = false
    }
  }

  function signOut(): void {
    authClient.logout()
    user.value = null
    window.location.assign(hostedUiLogoutUrl())
  }

  /** Called when the API reports 401 — the stored session is unusable. */
  function invalidateSession(): void {
    authClient.logout()
    user.value = null
  }

  return { user, error, busy, isSignedIn, signIn, completeSignIn, signOut, invalidateSession }
})
